import React from "react";
import BenefitsCard from "./BenefitsCard";
import facility from "../../assets/about-icons/facility-icon.svg";
import security from "../../assets/about-icons/security-icon.svg";
import transparent from "../../assets/about-icons/transparent-icon.svg";

const Benefits = () => {
  const arr = [
    {
      id: 1,
      title: "Transparan",
      desc: "Pembayaran anda baru diteruskan ke penjual setelah barang anda terima.",
      img: transparent,
    },
    {
      id: 2,
      title: "Aman",
      desc: "Bandingkan review untuk berbagai online shop terpercaya se-Indonesia.",
      img: security,
    },
    {
      id: 3,
      title: "Fasilitas Gratis",
      desc: "Fasilitas rekening bersama MoshiMoshi Mall tidak dikenakan biaya tambahan.",
      img: facility,
    },
  ]
  return (
    <div className="benefits container">
      {
        arr.map((data) => {
          return <BenefitsCard key={data.id} data={data} />;
        })
      }
    </div>
  );
};

export default Benefits;
